import { useState } from "react";
import { Button } from "./Button";

export function Hud({ ui, currentMap, limits, actions, busy, onOpenHostiles }) {
	const [menuOpen, setMenuOpen] = useState(false);
	const boost = ui.scoreMultiplier && Date.now() < ui.scoreMultiplier.expiresAt
		? Math.max(0, Math.ceil((ui.scoreMultiplier.expiresAt - Date.now()) / 1000))
		: 0;

	const runAction = (action) => {
		setMenuOpen(false);
		action();
	};

	return (
		<header className="hud">
			<div className="hud__map">
				<span className="map-dot" style={{ "--tone": currentMap.color }} />
				<div>
					<strong>{currentMap.name}</strong>
					<small>{ui.runMode === "survival" ? "Survival Mode" : `${ui.mapIdx + 1}/${limits.totalMaps} - ${currentMap.threat}`}</small>
				</div>
			</div>
			<div className="hud__stats" aria-label="Run stats">
				<span>Gold <strong>{ui.gold}</strong></span>
				<span>Lives <strong>{ui.lives}</strong></span>
				<span>Wave <strong>{ui.runMode === "survival" ? ui.wave : `${ui.wave}/${limits.wavesPerMap}`}</strong></span>
				<span>Score <strong>{ui.score}</strong></span>
				<span>Units <strong>{ui.runMode === "survival" ? `${ui.placedCount}/INF` : `${ui.placedCount}/${limits.unitLimit}`}</strong></span>
				{boost > 0 && <span className="boost-pill">1.5x {boost}s</span>}
			</div>
			<div className="hud__actions">
				<button
					type="button"
					className={`hud-menu-button ${menuOpen ? "is-open" : ""}`}
					aria-label="Open game menu"
					aria-expanded={menuOpen}
					onClick={() => setMenuOpen((current) => !current)}
				>
					<span />
					<span />
					<span />
				</button>
				{menuOpen && (
					<div className="hud-menu" role="menu" aria-label="Game actions">
						<Button tone="ghost" onClick={() => runAction(() => actions.backToMenu())}>Home</Button>
						<Button tone="ghost" onClick={() => runAction(actions.togglePause)}>{ui.paused ? "Resume" : "Pause"}</Button>
						<Button tone={ui.speed === 2 ? "warning" : "ghost"} onClick={() => runAction(actions.toggleSpeed)}>{ui.speed}x Speed</Button>
						<Button tone="ghost" onClick={() => runAction(() => onOpenHostiles?.())}>Hostiles</Button>
						<Button tone="ghost" onClick={() => runAction(actions.save)} disabled={busy.saving}>{busy.saving ? "Saving" : "Save"}</Button>
						<Button tone="ghost" onClick={() => runAction(actions.load)} disabled={busy.loadingSave}>{busy.loadingSave ? "Loading" : "Load"}</Button>
					</div>
				)}
			</div>
		</header>
	);
}
